import { isValidDateString } from '@/common/utils/dateValidator'
import { endOfDay, format, isAfter, isBefore, startOfDay } from 'date-fns';
import { z } from 'zod'

export const anticipateEndDateGovernmentAllocationSchema = z.object({
  requested_new_end_date: z
    .string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' }),
})

export const createAnticipateEndDateGovernmentAllocationSchema = (
  minDate: Date,
  maxDate: Date
) => {
  const normalizedMinDate = format(startOfDay(minDate), 'yyyy-MM-dd')
  const normalizedMaxDate = endOfDay(maxDate)


  return anticipateEndDateGovernmentAllocationSchema.extend({
    requested_new_end_date: anticipateEndDateGovernmentAllocationSchema.shape.requested_new_end_date
      .transform(value => value.split('/').reverse().join('-'))
      .refine((date) => !isBefore(date, normalizedMinDate), {
        message: 'A data não pode ser anterior à data de hoje.',
      })
      .refine((date) => !isAfter(date, normalizedMaxDate), {
        message: 'A data não pode ser posterior à data final do período de competência atual.',
      }),
  });
};

export type AnticipateEndDateGovernmentAllocationSchema = z.infer<typeof anticipateEndDateGovernmentAllocationSchema>
